import { Path } from '@/main/router/routerPath';

import { NAME, CRUMB_LABEL_KEY } from './constants';
import Edit from './Edit.vue';

export const router = new Path(NAME, { Edit }, CRUMB_LABEL_KEY);
